import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cabcac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col grow gap-4" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "sticky top-24"
}
const _hoisted_5 = { class: "overflow-auto bg-zinc-200 rounded" }
const _hoisted_6 = { class: "inline-block" }
const _hoisted_7 = { class: "grid sticky top-0 grid-flow-col auto-cols-max py-4 bg-zinc-100" }
const _hoisted_8 = { class: "flex flex-col gap-4 px-4 w-80 h-full" }
const _hoisted_9 = { class: "flex gap-2 items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Все характеристики ", -1))
const _hoisted_11 = { class: "flex gap-2 items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Только различия ", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Очистить список ")
const _hoisted_15 = { class: "mb-4 text-2xl font-bold text-zinc-400" }
const _hoisted_16 = { class: "mb-4 text-lg" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Убрать ")
const _hoisted_19 = { class: "grid grid-cols-1 divide-y divide-slate-400" }
const _hoisted_20 = { class: "flex gap-4 w-80" }
const _hoisted_21 = { class: "py-3 px-4 w-60" }
const _hoisted_22 = {
  key: 0,
  class: "flex-none w-20 divide-y divide-slate-400"
}
const _hoisted_23 = {
  key: 0,
  class: "flex flex-row gap-4 items-center"
}
const _hoisted_24 = {
  key: 1,
  class: "divide-y divide-slate-400"
}
const _hoisted_25 = { key: 2 }

import { computed, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios';
import AppPageTitle from './AppPageTitle.vue';
import { setTitle } from '../title';
import AppLoading from './AppLoading.vue';
import { Product } from '../types/Product';
import { Attribute } from '../types/Attribute';
import { useStore } from '../stores/main';
import { Year } from '../types/Year';
import { formatDataType } from '../formatters/valueFormatters';
import { TrashIcon } from '@heroicons/vue/outline';
import CountryFlag from 'vue-country-flag-next';
import { useStorage } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

setTitle('Сравнение');

const router = useRouter();
const route = useRoute();
const store = useStore();

const filterType = useStorage<'all' | 'difference'>('compareType', 'all');
const loading = ref(false);
const attributes = ref<Attribute[]>([]);
const products = ref<Product[]>([]);
const years = ref<Year[]>([]);

watch(
  () => route.query.p as string[],
  (productsIds) => {
    console.log(productsIds);
    
    if (!productsIds || !productsIds.length) {
      products.value = [];
      return;
    }
    
    if (!Array.isArray(productsIds)) {
      productsIds = [productsIds];
    }
    
    store.compare = {};
    
    productsIds.forEach((item) => {
      store.toggleCompare(item);
    });
    
    loading.value = true;
    axios
      .get(`/api/products/`, {
        params: {
          ids: productsIds,
        },
      })
      .then((response) => {
        if (!response || !response.data || !response.data.data) {
          throw new Error();
        }
        
        years.value = response.data.years;
        attributes.value = response.data.attributes;
        products.value = response.data.data;
        
        console.log(response);
      })
      .catch(() => {
        router.push({
          name: 'NotFound',
          params: {
            pathMatch: route?.path.substring(1)
              .split('/'),
          },
          query: route?.query,
          hash: route?.hash,
        });
      })
      .finally(() => {
        loading.value = false;
      });
  },
  {
    immediate: true,
  },
);

const removeProduct = (product: Product) => {
  store.toggleCompare(product.id);
  
  router.push({
    name: 'compare',
    query: {
      p: store.compareIds,
    },
  });
};

const clearList = () => {
  store.compare = {};
  
  router.push({
    name: 'compare',
    query: {
      p: store.compareIds,
    },
  });
};

const filteredAttributes = computed(() => {
  return attributes.value.filter((attribute) => {
    let hasValues = false;
    let tempValue = undefined;
    let hasDifference = false;
    
    products.value.forEach((product) => {
      if (attribute.byYear) {
        
        let allYearsValues = [];
        
        years.value.forEach((year) => {
          if (product.valuesByAttributeIdAndYearId[attribute.id + '-' + year.id]) {
            hasValues = true;
            allYearsValues.push(product.valuesByAttributeIdAndYearId[attribute.id + '-' + year.id].value);
            return false;
          }
        });
        
        if (tempValue === undefined) {
          tempValue = allYearsValues.join('-');
        } else {
          if (tempValue !== allYearsValues.join('-')) {
            hasDifference = true;
          }
        }
        
      } else {
        if (product.valuesByAttributeIdAndYearId[attribute.id]) {
          hasValues = true;
          
          if (tempValue === undefined) {
            tempValue = product.valuesByAttributeIdAndYearId[attribute.id].value;
          } else {
            if (tempValue !== product.valuesByAttributeIdAndYearId[attribute.id].value) {
              hasDifference = true;
            }
          }
          
          return false;
        }
      }
    });
    
    // if (attribute.id === 6) {
    //   console.log(attribute, hasDifference, tempValue)
    // }
    
    if (filterType.value === 'all') {
      return hasValues;
    }
    
    if (filterType.value === 'difference') {
      return hasValues && hasDifference;
    }
  })
    .sort((a, b) => {
      return a.title.localeCompare(b.title);
    });
});

const getValue = (attribute, product) => {
  return product.valuesByAttributeIdAndYearId[attribute.id]?.value || '—';
};

const getValueByYear = (year, attribute, product) => {
  return product.valuesByAttributeIdAndYearId[attribute.id + '-' + year.id]?.value || '—';
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppPageTitle, { title: "Сравнение" }),
    (loading.value)
      ? (_openBlock(), _createBlock(AppLoading, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!products.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Товары не добавлены в сравнение "))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(filterType) ? (filterType).value = $event : null)),
                            type: "radio",
                            value: "all",
                            class: "w-6 h-6 text-teal-400 rounded"
                          }, null, 512), [
                            [_vModelRadio, _unref(filterType)]
                          ]),
                          _hoisted_10
                        ]),
                        _createElementVNode("label", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filterType) ? (filterType).value = $event : null)),
                            type: "radio",
                            value: "difference",
                            class: "w-6 h-6 text-teal-400 rounded"
                          }, null, 512), [
                            [_vModelRadio, _unref(filterType)]
                          ]),
                          _hoisted_12
                        ]),
                        _createElementVNode("a", {
                          href: "#",
                          class: "flex gap-1 items-center mt-auto text-zinc-600 hover:text-teal-600",
                          onClick: _withModifiers(clearList, ["prevent"])
                        }, [
                          _createVNode(_unref(TrashIcon), { class: "w-4 h-4" }),
                          _hoisted_14
                        ], 8, _hoisted_13)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: product.id,
                          class: "flex flex-col w-64"
                        }, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(product.brand.title), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(product.title), 1),
                          _createElementVNode("a", {
                            href: "#",
                            class: "flex gap-1 items-center mt-auto text-zinc-600 hover:text-teal-600",
                            onClick: _withModifiers(($event: any) => (removeProduct(product)), ["prevent"])
                          }, [
                            _createVNode(_unref(TrashIcon), { class: "w-4 h-4" }),
                            _hoisted_18
                          ], 8, _hoisted_17)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredAttributes), (attribute) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: attribute.id,
                          class: "grid grid-flow-col auto-cols-max items-center"
                        }, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(attribute.title), 1),
                            (attribute.byYear)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: year.id,
                                      class: "py-3"
                                    }, _toDisplayString(year.value) + "г. ", 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: product.id,
                              class: "w-64"
                            }, [
                              (!attribute.byYear && product.valuesByAttributeIdAndYearId[attribute.id])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (attribute.dataType === 'country')
                                      ? (_openBlock(), _createBlock(_unref(CountryFlag), {
                                          key: 0,
                                          class: "block flex-none !my-0",
                                          country: getValue(attribute, product)
                                        }, null, 8, ["country"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(_unref(formatDataType)(attribute.dataType, getValue(attribute, product))), 1)
                                  ]))
                                : (attribute.byYear)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: year.id,
                                          class: "py-3"
                                        }, _toDisplayString(_unref(formatDataType)(attribute.dataType, getValueByYear(year, attribute, product))), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_25, " — "))
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
        ]))
  ]))
}
}

})